import type { SVGProps } from 'react';
const SvgPagRightArrowOne = (props: SVGProps<SVGSVGElement>) => (
  
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.44 4L6.5 4.94L9.55333 8L6.5 11.06L7.44 12L11.44 8L7.44 4Z"
      fill="black"
    />
  </svg>
);
export default SvgPagRightArrowOne;
